/* eslint-disable */
import Vue from 'vue';
import {
  ServerTable,
  ClientTable
} from 'vue-tables-2';
import Breabcrumbs from 'vue-2-breadcrumbs';
import jQuery from 'jquery';
window.jQuery = jQuery;
import 'bootstrap/dist/js/bootstrap';
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App';
import router from './router';
import store from './store';

import VueStorage from 'vue-ls';
import config from './config/defaultSettings';
import bootstrap from '@/core/bootstrap';
import { MessageBox, Notification } from 'uiv';

Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$notify = Notification.notify;

Vue.config.productionTip = false;

axios.defaults.baseURL = (process.env.NODE_ENV === "production") ? 'https://api.cat4mro.com' : 'http://localhost:8081';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.use(VueStorage, config.storageOptions);
Vue.use(VueAxios, axios)
Vue.use(ServerTable);
Vue.use(ClientTable);
Vue.use(Breabcrumbs, {
  template: '<nav v-if="$breadcrumbs.length" aria-label="breadcrumb">\n' +
    '            <ol class="breadcrumb">\n' +
    '                <li>Home</li>' +
    '                <li v-for="(crumb, key) in $breadcrumbs" v-if="crumb.meta.breadcrumb" :key="key" class="breadcrumb-item active" aria-current="page">\n' +
    '                    <router-link :to="{ path: crumb.path }">{{ getBreadcrumb(crumb.meta.breadcrumb) }}</router-link>' +
    '                </li>\n' +
    '            </ol>\n' +
    '        </nav>',
});

require('vue-multiselect/dist/vue-multiselect.min.css');
require('./assets/css/bootstrap.css');
require('./assets/css/header.css');
require('./assets/css/sidebar.css');
require('./assets/css/forms.css');
require('./assets/css/buttons.css');
require('./assets/css/style.css');
require('./assets/css/font-awesome.min.css');
require('./assets/css/bootstrap-select.min.css');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  created() {
    bootstrap();
  },
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js